export default function PageNotFound() {
    return (
        <main className="main-container main-container--flex-row | flex">
            <div className="flex | pageNotFound-container">
                <p className="fw-bold text-primary-dark fs-700">404</p>
                <p>There's nothing here!</p>
            </div>
        </main>
    );
}
